document.addEventListener('DOMContentLoaded',function(){
  const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
          (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };

  var element_in_viewport = document.querySelector('header');
  window.addEventListener('scroll',function(){
    if(elementIsVisibleInViewport(element_in_viewport) == false){
      document.body.classList.add('sticky_content');
    }else{document.body.classList.remove('sticky_content');}
  })
})